import $ from 'jquery';

import { LeadPopupCtrl } from '../lead.popup/lead.popup.controller';
import leadPopupTemplate from '../lead.popup/lead.popup.html';
import template from '../tasks.overview/tasks.overview.html';
import { UnitPopupCtrl } from '../unit.popup/UnitPopupCtrl';
import unitPopupTemplate from '../unit.popup/unit.popup.html';
import { TasksOverviewCtrl } from './tasks.overview.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('tasks', {
      url: '/tasks',
      controller: TasksOverviewCtrl,
      controllerAs: 'vm',
      template,
    })
    .state('tasks.leadpopup', {
      url: '/leadpopup/:id',
      views: {
        sidebar: {
          controller: LeadPopupCtrl,
          controllerAs: 'vm',
          template: leadPopupTemplate,
        },
      },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('tasks.unitpopup', {
      url: '/unitpopup/:id',
      views: {
        sidebar: {
          controller: UnitPopupCtrl,
          controllerAs: 'vm',
          template: unitPopupTemplate,
        },
      },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    });
}
